import './styles.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button, Container, Nav, Navbar, OverlayTrigger, Tooltip
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

export function getHeaderTitle(envText) {
  if (envText && envText !== 'prd') {
    return `Connected Cloud Console (${envText}) - Launcher`;
  }

  return 'Connected Cloud Console - Launcher';
}

export function Header(props) {
  const { environment, auth } = props;

  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" fixed="top" variant="dark" className="Header">
      <Container>
        <Navbar.Brand href="/launcher" className="Header__Brand">
          { getHeaderTitle(environment) }
          <FontAwesomeIcon className="pl-2" icon="rocket" size="lg" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        { auth.user && (
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ml-auto" as="ul">
              <Nav.Item as="li" role="presentation" className="d-xl-flex align-items-xl-center">
                <OverlayTrigger
                  placement="bottom"
                  overlay={(
                    <Tooltip id="tooltip-user">
                      { auth.user }
                    </Tooltip>
                  )}
                >
                  <FontAwesomeIcon
                    icon="user"
                    size="lg"
                    className="Header__FontAwesomeIcon--user text-light"
                  />
                </OverlayTrigger>
              </Nav.Item>
              <Nav.Item as="li" role="presentation" className="d-xl-flex align-items-xl-center">
                <NavLink to="/logout">
                  <Button variant="primary" size="sm">LOGOUT</Button>
                </NavLink>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        )}
      </Container>
    </Navbar>
  );
}

function mapStateToProps(state) {
  return state;
}

Header.defaultProps = {
  auth: {
    user: null,
  },
  environment: undefined,
};

Header.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.string,
  }),
  environment: PropTypes.string,
};

export default connect(mapStateToProps)(Header);
